import { qs } from "url-parse";
import { getPartnerUrl, getCabinetUrl } from "../config/cabinet";
import { getCabinetType } from "../config/api";

const AuthService = {
  isAuth: () => {
    return AuthService.getUserToken() !== "";
  },
  saveUserToken: token => {
    window.localStorage.setItem("token", token);
  },
  deleteUserToken: () => {
    window.localStorage.removeItem("token");
  },
  getUserToken: () => {
    return window.localStorage.getItem("token") || "";
  },
  authenticate: token => {
    const params = qs.parse(window.location.search);
    const _token = token || params.token;

    if (_token) {
      AuthService.saveUserToken(_token);
    }
  },
  redirectToApp: () => {
    const redirectUrl = window.localStorage.getItem("redirectUrl");
    const cabinetUrl = redirectUrl || getCabinetUrl();

    if (window.location.href !== cabinetUrl) {
      window.localStorage.removeItem("redirectUrl");
      window.location.href = cabinetUrl;
    }
  },
  redirectToLogin: () => {
    const loginUrl = `//${
      process.env.PARTNER_HOST
    }/user/login/${getCabinetType()}`;

    if (window.location.href !== loginUrl) {
      window.localStorage.setItem("redirectUrl", window.location.href);
      window.location.href = loginUrl;
    }
  }
};

export default AuthService;
